import React, { useState } from "react";
import ActionFormatter from "Components/Table/ActionFormatter/ActionFormatter";
import AlertDialog from "Components/AlertDialog/AlertDialog";
import { read, store } from "Helpers/LocalStorage";
import { useDispatch, useSelector } from "react-redux";
import { deleteProject } from "Stores/actions";
import Translator from "Languages/Utility/Translator";
import { ALL_PROJECT_LIST, SELECTED_PROJECT, UNIT_INFO } from "Stores/actionTypes";
import showNotify from "Helpers/Notify";
import { useTranslation } from 'react-i18next';
import * as Icons from 'react-bootstrap-icons';

function DeleteProject({ row }) {
  const { t } = useTranslation();
  const { selectedProject, projectsList, projectsListPagination } = useSelector((state) => ({
    selectedProject: state.project.selectedProject,
    projectsList: state.project.projectsList,
    projectsListPagination: state.project.projectsListPagination,
  }));
  const [showAlert, setShowAlert] = useState(false);
  const [deleteRelationData, setDeleteRelationData] = useState(null);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const onShowAlert = () => {
    if (row.IsLock && (read("StypeU")=== "2" || read("StypeU")=== "5" ||read("UserC") === "zero")) {
      showNotify({
        text: t('lockedProject'),
        customClass: "error",
      });
    } else {
      setShowAlert(!showAlert);
      setDeleteRelationData(null);
    }
  };

  const onDelete = async () => {
    try {
      setLoading(true);
      const data = {
        KeyGroup: read("groupKey"),
        KeyUser: read("userKey"),
        Id: row.Id,
      };
      const res = await dispatch(deleteProject(data));
      if (res) {
        onShowAlert();
        dispatch({
          type: ALL_PROJECT_LIST,
          projectsList: projectsList.filter((item) => item.Id !== row.Id),
          projectsListPagination: projectsListPagination,
        });
        if(selectedProject.Id === row.Id) {
          dispatch({
            type: SELECTED_PROJECT,
            selectedProject: "undefined",
          });
          store("project", undefined);
          store("unitId", undefined);
          dispatch({ type: UNIT_INFO, unitInfo: null });
        }
      }
      setLoading(false);
    } catch (err) {
      console.error('[catch error]', err)
    }
  };

  return (
    <>
      <ActionFormatter
        title={<Translator id="hazf" />}
        icon={<Icons.Trash3 size={17} />}
        className="danger-fill"
        onClick={onShowAlert}
      />
      <AlertDialog
        showAlert={showAlert}
        type="alertError"
        onClose={onShowAlert}
        onClickOk={onDelete}
        okTitle={<Translator id="ble_pak_shavad" />}
        cancelTitle={<Translator id="enseraf" />}
        questionText={<Translator id="aya_az_hazf_an_etminan_darid" />}
        relationText={<Translator id='relationAlert' />}
        relationData={deleteRelationData}
        loading={loading}
      />
    </>
  );
}

export default DeleteProject;
